import { render, staticRenderFns } from "./termsAndCondition.vue?vue&type=template&id=507e032a&scoped=true"
import script from "./termsAndCondition.vue?vue&type=script&lang=js"
export * from "./termsAndCondition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507e032a",
  null
  
)

export default component.exports